export default "__VITE_ASSET__98798e9b__"